module.exports = __webpack_public_path__ + "static/media/E8.944bba4.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/E8.mp4
// module id = pZUb
// module chunks = 8